import axios from "axios";
import { serialize } from "./utils";

const API_URL = process.env.NODE_ENV === 'production'
		? "https://" + window.location.hostname + "/api"
		: "http://" + window.location.hostname + ":5000/api";

export function authenticate(userData) {
	return axios.post(`${API_URL}/auth`, userData);
}

export function user(token) {
	return axios.get(`${API_URL}/user`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function users(token, settings = {}) {
	return axios.get(`${API_URL}/users?${serialize(settings)}`, {
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function oneUser({token, id}) {
	return axios.get(`${API_URL}/user/${id}`, {
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function saveUser({token, usr}) {
	return axios.put(`${API_URL}/user/${usr.id}`, usr,{
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function createUser({token, usr}) {
	return axios.post(`${API_URL}/user`, usr,{
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function userUpdate({ token, pin }) {
	return axios.put(
		`${API_URL}/user`,
		{ pin },
		{ headers: { Authorization: `Bearer ${token.jwt}` } }
	);
}

export function projects({
	token,
	all,
	done,
	search,
	page,
	limit,
	paginate,
	members
}) {
	let query = {};

	if (!all) query.mine = "true";
	else query.all = "true";

	if (done !== null) query.done = done ? "true" : "false";

	if (search) query.search = search;

	if (limit) query.limit = limit;

	if (page) query.page = page;

	if (paginate) query.paginate = `true`;

	if (members && members.length !== 0) {
		query.members = members;
	}

	return axios.get(`${API_URL}/projects?${serialize(query)}`, {
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function project({ token, id }) {
	return axios.get(`${API_URL}/projects/${id}`, {
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function projectUpdate({ token, id, data }) {
	return axios.put(`${API_URL}/projects/${id}`, data, {
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function projectPost({ token, data }) {
	return axios.post(`${API_URL}/projects`, data, {
		headers: { Authorization: `Bearer ${token.jwt}` }
	});
}

export function runningActivity(token) {
	return axios.get(`${API_URL}/jobs`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function sendStartActivity(token, data = {}) {
	return axios.post(`${API_URL}/jobs`, data, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function sendStopActivity(token, data) {
	return axios.put(`${API_URL}/jobs`, data, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function latestActivity(token, params = {}) {

	let allParams = {};
	for(let param in params) {
		if(typeof params[param] !== 'undefined') {
			allParams[param] = params[param];
		}
	}

	return axios.get(`${API_URL}/activities?${serialize(allParams)}`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function updateProjectCredential({ token, credential }) {
	return axios.put(`${API_URL}/projects/credentials`, credential, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function newProjectCredential({ token, credential }) {
	return axios.post(`${API_URL}/projects/credentials`, credential, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function deleteProjectCredential({ token, credential }) {
	return axios.delete(`${API_URL}/projects/credentials`, {
		data: credential,
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function tags({ token }) {
	return axios.get(`${API_URL}/tags`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function notes({ token }) {
	return axios.get(`${API_URL}/projects/notes`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function newNote({ token, note }) {
	return axios.post(`${API_URL}/projects/notes`, note, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function updateNote({ token, note }) {
	return axios.put(`${API_URL}/projects/notes`, note, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function deleteNote({ token, note }) {
	return axios.delete(`${API_URL}/projects/notes`, {
		data: note,
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function newTaskGroup({ token, group }) {
	return axios.post(`${API_URL}/task/group`, group, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function tasks({ token, project }) {
	return axios.get(`${API_URL}/task/group?project_id=${project.project_id}`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function newTask({ token, task }) {
	return axios.post(`${API_URL}/task`, task, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function updateTask({ token, task }) {
	return axios.put(`${API_URL}/task`, task, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function deleteTask({ token, task }) {
	return axios.delete(`${API_URL}/task`, {
		data: task,
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function clients({ token, settings }) {
	let query = serialize(settings);

	return axios.get(`${API_URL}/clients?${query}`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function client({token, client}) {
	return axios.get(`${API_URL}/client/${client}`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function saveClient({token, client}) {
	return axios.put(`${API_URL}/client/${client.id}`, client, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function createClient({token, client}) {
	return axios.post(`${API_URL}/clients`, client, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function statuses({ token }) {
	return axios.get(`${API_URL}/statuses`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function types({token}) {
	return axios.get(`${API_URL}/user_types`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function events({token}) {
	return axios.get(`${API_URL}/events`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function postEvent({token, data}) {
	return axios.post(`${API_URL}/events`, data, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function deleteGroup({token, group}) {
	return axios.delete(`${API_URL}/task/group`, {
		data: group,
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function stats({token, filters}) {
	return axios.get(`${API_URL}/stats?${serialize(filters)}`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function activity({token, data}) {
	return axios.get(`${API_URL}/activity?${serialize(data)}`, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function saveActivity({token, data}) {
	return axios.put(`${API_URL}/activity?id=${data.id}`, data, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

export function saveActivityMulti({token, data}) {
	return axios.post(`${API_URL}/activity`, data, {
		headers: { Authorization: `Bearer ${token}` }
	});
}